module.exports = __webpack_public_path__ + "static/media/gim4.a65110ae.jpg";